import { createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';
import axios from 'axios';
import { fetchApiAuth } from '../utils/api';
import {
    GetProjectCategoriesResponse,
    GetSchoolProjectsRequest,
    GetSchoolProjectsResponse,
    CreateOrUpdateProjectRequest,
    CreateOrUpdateProjectResponse,
    ExportProjectsRequest,
    DeleteProjectRequest,
    DeleteProjectResponse,
} from './types';

// Define ResponseProps type
interface ResponseProps {
    data: any;
}

export const getProjectCategories = createAsyncThunk(
    'projects/get-project-categories',
    async () => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/project/get-project-categories',
                body: {},
            });
            return response.data as GetProjectCategoriesResponse;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const getSchoolProjects = createAsyncThunk(
    'projects/get-school-projects',
    async (payload: GetSchoolProjectsRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/project/get-school-projects',
                body: payload,
            });
            return response.data as GetSchoolProjectsResponse;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const createOrUpdateProject = createAsyncThunk(
    'projects/create-or-update-project',
    async (payload: CreateOrUpdateProjectRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/project/create-or-update-project',
                body: payload,
            });
            return response.data as CreateOrUpdateProjectResponse;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const exportProjects = createAsyncThunk(
    'projects/export-projects',
    async (payload: ExportProjectsRequest) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: 'v1/project/export-projects',
                body: payload,
                responseType: 'blob',
            });
            return response;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);

export const deleteProject = createAsyncThunk(
    'projects/delete-project',
    async (payload: DeleteProjectRequest) => {
        try {
            const response: ResponseProps = await fetchApiAuth({
                method: 'POST',
                url: 'v1/project/delete-project',
                body: payload,
            });
            return response.data as DeleteProjectResponse;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const errorMessage = (error.response?.data.message as string) || 'Something went wrong';
                notification.error({
                    message: 'Error',
                    description: errorMessage,
                });
            }
            throw error;
        }
    },
);
